import { PrimeNgModule } from '@shared/prime-ng/prime-ng.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { UserProfileWidgetComponent } from './user-profile-widget/user-profile-widget.component';
import { InternalUserDetailsComponent } from './internal-user-details.component';
import { AssignUserGroupsComponent } from './assign-usergroups/assign-usergroups.component';

@NgModule({
  declarations: [
    InternalUserDetailsComponent,
    UserProfileWidgetComponent,
    AssignUserGroupsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    PrimeNgModule
  ],
  exports: [InternalUserDetailsComponent]
})
export class InternalUsersDetailsModule {}
